<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.88046875,0.9999999403953552C7.88046875,0.9999999403953552,2.98046875,7.2799999403953555,2.98046875,9.899999940395356C2.99046875,12.719999940395356,5.32046875,14.999999940395355,7.97046875,14.999999940395355C10.62046875,14.989999940395355,13.00046875,12.699999940395355,13.00046875,9.869999940395354C12.99046875,7.169999940395355,7.88046875,0.9999999403953552,7.88046875,0.9999999403953552C7.88046875,0.9999999403953552,7.88046875,0.9999999403953552,7.88046875,0.9999999403953552Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Tint',
} as DefineComponent
</script>
